module.exports = __webpack_public_path__ + "img/agentinstfirst.7d89d171.png";